import { clsx } from 'clsx'

// Utility function for combining class names
// This function uses clsx to merge class names safely
export function cn(...inputs) {
  return clsx(inputs)
} 